<template>
  <v-app>
    <v-container fluid style="width: 100%; height: 100%;">
      <v-app-bar
        color="white"
        dense
        fixed
        class="apptoolbar"
      >
      <a href="https://www.oecd.org" target=_new><img src="./assets/img/oecd-logo.png" class="oecd_header" ></a>
      <img src="./assets/img/Logo-data-viz-top.png" class="oecd_header">

        <v-spacer></v-spacer>
        <span class="oecd_box_top cursorhand" @click="about">About</span>
        <!--
        <span class="oecd_box_top">Glossary</span>
        -->
        <span class="oecd_box_top mr-10  cursorhand" @click="contact">Contact <v-icon  small class="ml-1">mdi-email</v-icon></span>
      </v-app-bar>

      <div class="grid-container mt-12">
        <!-- <div class="item1">Header</div> -->
        <div class="item2">          
          <FilterComponent :show="true" @goHome="resetCountry" @filterChanged="filterChgd" :currentYear="currYear" :rstCountry="rstCountry" :chgRegCity="chgRegCity" />
        </div>
        <div class="item3">
          <RegionCityTab @changeRegCity="changeRegCity" @resetCountry="resetCountry" :filterChg="filterChanged"/>
          <router-view class="ml-4 mt-n3"/>
          <span v-if="isIsrael" class="size8">The statistical data for Israel are supplied by and under the responsibility of the relevant Israeli authorities. The use of such data by the OECD is without prejudice to the status of the Golan Heights, East Jerusalem and Israeli settlements in the West Bank under the terms of international law</span>
        </div>  
        <div class="item4">
          <PanelSection @resetCountry="resetCountry"/>
        </div>
        <div class="item5">
        </div>
      </div>
      <YearSelector @setYear="changeCurrYear" @setLastYearAvailable="setLYA" @showSource="showSource" @showDisclaimer="showDisclaimer" :currentYear="currentYear"/>
      <ManageLayer :currentYear="currentYear"/>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64">{{progressValue}}</v-progress-circular>
      </v-overlay>

    <v-dialog
      v-model="dialog"
      width="800"
    >
      <v-card>
        <v-card-title class="opensansbold size13 blue-grey lighten-4">
          {{dialogTitle}}
        </v-card-title>
        <v-card-text class="mt-4 opensansnormal size12" v-html="dialogMessage">
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    </v-container>
  </v-app>
</template>

<script>


import FilterComponent from '@/components/FilterComponent'
import YearSelector from '@/components/YearSelector'
import PanelSection from '@/components/PanelSection'
import RegionCityTab from '@/components/RegionCityTab'
import ManageLayer from '@/components/ManageLayer'

import axios from 'axios'
import proj4 from 'proj4'
import {register} from 'ol/proj/proj4'
import {get as getProjection} from 'ol/proj'


export default {
  name: 'App',
  components: {PanelSection, FilterComponent, RegionCityTab, YearSelector, ManageLayer},               
   watch: {
    '$route' () {
      this.getParams()
    },
    '$store.getters.show_overlay': function() {
        this.overlay = this.$store.getters.show_overlay
    }
  },   
  methods: {
    showSource: function () {
      this.dialog = true
      this.dialogTitle = "Source"
      this.dialogMessage ="Source of administrative boundaries: National Statistical Offices, Eurostat (European Commission) © EuroGeographics and FAO Global Administrative Unit Layers (GAUL).<br><br>The indicators shown in this web-platform are available in the OECD statistical portal <a href=\"https://stats.oecd.org/\" target=_new>https://stats.oecd.org/</a>, except for the indicators for grid-based functional urban areas with world coverage (dataset).<br><br>All indicators can be downloaded from the platform in CSV format. The downloaded file reports the links to the source and the definition of the indicator.<br><br>"
    },
    showDisclaimer: function () {
      this.dialog = true
      this.dialogTitle = "Disclaimer"
      this.dialogMessage ="Any map shown herein, are without prejudice to the status of or sovereignty over any territory, to the delimitation of international frontiers and boundaries and to the name of any territory, city or area.<br>The statistical data for Israel are supplied by and under the responsibility of the relevant Israeli authorities.<br>The use of such data by the OECD is without prejudice to the status of the Golan Heights, East Jerusalem and Israeli settlements in the West Bank under the terms of international law."
    },
    contact: function () {
      this.dialog = true
      this.dialogTitle = "Contact"
      this.dialogMessage ="For any question, please send an email to <a href=\"mailto:RegionStat@oecd.org\">RegionStat@oecd.org</a>"
    },
    about: function () {
      this.dialog = true
      this.dialogMessage = "<p class=\"text-justify\">The OECD Regions and Cities Data Visualisation is a web-platform developed by the "+
      "<a href=\"http://www.oecd.org/cfe/\" target=_new>OECD Centre for Entrepreneurship, SMEs, Regions and Cities (CFE)</a>. It helps users to select and visualise in a map or in a chart, any statistical indicator at the subnational scale made available by CFE through the OECD statistical portal <a href=\"https://stats.oecd.org/\" target=_new>https://stats.oecd.org/</a> plus selected additional indicators. </p><p class=\"text-justify\">The available indicators cover primarily OECD member countries, but a sub-set of indicators have wider coverage, up to the entire world.The user can visualise indicators at two main scales: regions and cities. Regions are further distinguished in large regions (TL2) and small regions (TL3). Indicators under the “Cities” tab refer to functional urban areas (FUAs), a <a href=\"https://www.oecd-ilibrary.org/governance/oecd-regional-development-working-papers_20737009\">definition</a> developed by the OECD and the European Commission to make international comparisons of city statistics. FUAs are composed of cities of at least 50,000 inhabitants plus their surrounding commuting zones (local units or grid cells that are connected to the city in terms of labour market interactions).</p>"+
      "<h5 class=\"opensanslight size9 text-justify\">Disclaimers:</h5><p class=\"opensanslight size9 text-justify\"><i>Any map shown herein, are without prejudice to the status of or sovereignty over any territory, to the delimitation of international frontiers and boundaries and to the name of any territory, city or area.</i><br>"+
      "<i>The statistical data for Israel are supplied by and under the responsibility of the relevant Israeli authorities. The use of such data by the OECD is without prejudice to the status of the Golan Heights, East Jerusalem and Israeli settlements in the West Bank under the terms of international law.</i></p>"
      this.dialogTitle = "About"
    },
    setLYA: function (l) {
      this.lastYearAvailable = l
      if (l) {
        this.$store.commit('setYear', 'LYA')
        this.currentYear =  'LYA'
      } else {
        let params = this.$route.params
        this.$store.commit('setYear', params.year)
        this.currentYear =  params.year
      }
      this.$root.$emit('component_refresh')
      this.$root.$emit('remove_legend_from_map')
    },
    calcThreshold: function (ds) {
        this.thresholds = []
        if (ds.thresholds) {
            this.thresholds = ds.thresholds
        }
        if (ds.thresholdsColors) {
          console.log(ds.thresholdsColors)
          this.$store.dispatch('setLegendColors', ds.thresholdsColors)
        }
        this.$store.commit('setshow_overlay', false)
        this.$store.commit('setLegendThresholds', this.thresholds)
    },
    fetchData: async function (params) {
      console.log(' **** FETCH DATA ****')
      let self = this    
      let tl = params.tl.replace("TL", "")
      let indicod = params.indicod
      console.log(tl)
      console.log(indicod)
      // disable next line to disable cache
      let urlToCall = null
      let urlToCallMetadata = null
      let urlToCallYears = null
      if (tl === "2" || tl === "3") {
        urlToCall = '/cache-data/REGS/REGS-' + tl + '-' + indicod + '.json'
        urlToCallMetadata = '/cache-metadata/REGS/REGS-' + tl + '-' + indicod + '.json'
        urlToCallYears = '/cache-years/REGS/' + tl + '-' + indicod + '.json'
        console.log(urlToCall)
        this.loadLegendColor(0)
      }
      if (tl === "EFUA") {
        urlToCall = '/cache-data/EFUA/FC-EFUA-DATASET-' + indicod + '.json'
        urlToCallMetadata = '/cache-metadata/EFUA/FC-EFUA-DATASET-' + indicod + '.json'
        urlToCallYears = '/cache-years/EFUA/FC-EFUA-DATASET-' + indicod + '.json'
        this.loadLegendColor(1)
      }
      if (tl === "CY") {
        urlToCall = '/cache-data/CITIES/FC-CY-' + indicod + '.json'
        urlToCallMetadata = '/cache-metadata/CITIES/FC-CY-' + indicod + '.json'
        urlToCallYears = '/cache-years/CITIES/FC-CY-' + indicod + '.json'
        this.loadLegendColor(1)
      }
      if (tl === 'FUA') {
        urlToCall = '/cache-data/FUA/FC-FUA-' + indicod + '.json'
        urlToCallMetadata = '/cache-metadata/FUA/FC-FUA-' + indicod + '.json'
        urlToCallYears = '/cache-years/FUA/FC-FUA-' + indicod + '.json'
        this.loadLegendColor(1)
      }

      console.log(urlToCall)
      console.log(urlToCallMetadata)
      console.log(urlToCallYears)

      console.log('*** READ YEARS ***')
      let years = []
      await axios.get(urlToCallYears)
        .then(response => {
          console.log(response)
          let js = null
          //console.log(tl)
          js = response.data
          console.log(js)
          years = js
        })
        .catch(e => {
          console.log(e)
      })

      /*
      let key_years = tl + '-' + indicod
      if (tl === '2') {
        years = self.years2[key_years]
      }
      if (tl === '3') {
        years = self.years3[key_years]
      }
      */
      console.log(years)

      if (years.length === 0 && (tl === '2' || tl === '3')) {
        this.dialogTitle = 'Warning!'
        this.dialogMessage = 'The indicator chosen contains no data.'
        this.dialog =  true
        return false
      }
      
      console.log(urlToCall)
      console.log(urlToCallMetadata)
      console.log(urlToCallYears)

      await axios.get(urlToCallMetadata)
        .then(response => {
          console.log(response)
          let js = null
          //console.log(tl)
          js = response.data
          this.calcThreshold(js)
        })
        .catch(e => {
          console.log(e)
      })


      return await axios.get(urlToCall)
        .then(response => {
          console.log(response)
          let js = null
          //console.log(tl)
          js = response.data
          //console.log(js)
          this.$store.dispatch('setds', js)
          // this.calcThreshold(js)
          //console.log(js.dataset)   
          years = []
          Object.entries(js.dataset).forEach(([key]) => {
            // console.log(`${key} ${value}`); // "a 5", "b 7", "c 9"
            if (key !== 'LYA') {
              years.push(key)
            }
          })   
          years.sort()
          this.$root.$emit('change_year_range',years)
          self.available_years = years
          this.$store.dispatch('setYears', years)
          return true
        })
        .catch(e => {
          console.log(e)
          //alert('NO DATA')
          let ds = []
          ds.data = []
          this.$root.$emit('change_year_range',[])            
          this.$store.dispatch('setds', ds)
          this.$store.dispatch('setIndicator', '')
          this.$store.dispatch('setIndicatorUnit', '')
          this.$store.dispatch('setLegendThresholds', null)
          console.log(">>> manage_country_polygon from: FilterComponent:fetchdata - catcherror")
          return false
        })
    },
    getParams: async function () {
      console.log("***** GET PARAMS ******")
      let params = this.$route.params
      let query = this.$route.query

      console.log(params)
      // If no parameters, set basic parameters
      if (!this.$route.name) {
        let name = 'Home'
        params.tl = 'x'
        params.tu = 'x'
        params.c = 'x'
        params.indicod = 'x'
        params.year = 'x'
        this.$router.replace({ name: name, params: params, query: query}).catch(()=>{})
        return 
      }
      let wrongParams = false
      let p_tl = params.tl
      // If wrong TL set defaul tl (TL2)
      if (p_tl != 'EFUA' && p_tl != 'FUA' && p_tl != 'TL2' && p_tl != 'TL3' && p_tl != 'CY') {
        wrongParams = true
        params.tl = 'TL2'
        p_tl = params.tl
      }
      // If no indicod, set defaul indicod based on tl
      let p_indicod = params.indicod
      if (p_indicod === '' || p_indicod === 'x') {
        wrongParams = true
        // Default indicod
        // TL2 e TL3: REGION_DEMOGR-T-T
        // FUA:  T_T
        // EFUA:  T_T 
        switch (p_tl) {
          case 'TL2':
          case 'TL3':
            params.indicod = 'REGION_DEMOGR-T-T'
            query = {}
          break
          case 'FUA':
          case 'EFUA':
          case 'CY':
            params.indicod = 'T_T'
            console.log(this.$store.getters.indicatorsForCode)
            var sz = this.$store.getters.indicatorsForCode[p_tl + '-' + params.indicod] 
            if (sz) {
              query = {showzero: sz.ShowZero}
            }
          break
        }
      }
      // if wrong parameters push new right parameters
      if (wrongParams) {
        let name = this.$router.currentRoute.name
        this.$router.replace({ name: name, params: params, query: query}).catch(()=>{})
        return false
      }
      // get parameters ok
      let tu = this.$store.getters.TU
      // let tl = this.$store.getters.TL
      let country  = this.$store.getters.countryID
      // let year = this.$store.getters.year
      // let indicator = this.$store.getters.indicator
      // init all maps

      if (p_tl === 'FUA' && params.tu !== 'x') {
        await this.loadFUASPolygon(params.tu)
      }
      if (p_tl === 'EFUA' && params.tu !== 'x') {
        await this.loadEFUAPolygon(params.tu)
      }
      if (p_tl === 'CY' && params.tu !== 'x') {
        await this.loadCYPolygons(params.tu)
      }
      this.$root.$emit('manage_layers')
      this.$root.$emit('initMap')

      let updatedContext = false
      let storeDataID = params.tl + '-' + params.indicod
      if ( this.$store.getters.lastStoreData !== storeDataID) {
        this.$store.dispatch('setLastStoreData', storeDataID)
        console.log("set store ID")
        this.$store.dispatch('setshow_overlay', true)
        let validData = null
        validData =  await this.fetchData(params)
        this.$store.dispatch('setshow_overlay', false)
        updatedContext = true
        if (!validData) {
          return false
        }
        

      }

      if (params.year === 'x') {
        if (params.year === 'x') {
          params.year = this.available_years[this.available_years.length -1]
          this.$store.commit('setYear', params.year)
          let name = this.$router.currentRoute.name
          this.$router.replace({ name: name, params: params, query: query}).catch(()=>{})
          return false
        }
        this.$store.commit('setYear', params.year)
      } else {
        let y = params.year
        console.log(y)
        console.log(this.available_years)
        console.log(this.available_years.includes(y.toString()))
        if (!this.available_years.includes(y.toString())) {
          params.year = this.available_years[this.available_years.length -1]
          console.log(params.year)
          this.$store.commit('setYear', params.year)
          let name = this.$router.currentRoute.name
          this.$router.replace({ name: name, params: params, query: query}).catch(()=>{})
          return false
        }
        this.$store.commit('setYear', params.year)
      }
      if ( tu !== params.tu) {
        if (params.tu !== 'x') {
          this.$store.commit('setTU', params.tu)
        } else {
          this.$store.commit('setTU', '')
        }
      }
      if ( country !== params.c) {
        
        if (params.c !== 'x') {
          let country_obj = this.$store.getters.getCountryById(params.c)
          if (country_obj) {
            let country = country_obj.name
            this.$store.commit('setCountryInfo', country_obj)
            this.$store.commit('setCountry', country)
            this.$store.commit('setCountryID', params.c)
          }
          else {
          this.$store.commit('setCountry', '')
          this.$store.commit('setCountryID', params.c)
          }
        } else {
          this.$store.commit('setCountry', '')
          this.$store.commit('setCountryID', '')
        }
      }
      this.$store.commit('setTL', params.tl)
      this.$store.commit('setIndicator', params.indicod)

      if (this.lastYearAvailable) {
        this.$store.commit('setYear', 'LYA')
        this.currentYear =  'LYA'
      }
      else {
        this.$store.commit('setYear', params.year)
        this.currentYear =  params.year
      }
      if (this.$route.name !== this.prevName && !updatedContext) {
        this.prevName = this.$route.name
      }
      console.log('*** COMPONENT REFRESH ***')
      this.$root.$emit('component_refresh')
      this.$root.$emit('remove_legend_from_map')
      
      if (params.c === 'ISR') {
        this.isIsrael = true
      } else {
        this.isIsrael = false
      }
      return true
    },
    filterChgd: function () {
      this.filterChanged = !this.filterChanged
    },
    changeCurrYear: function (y) {
      this.$store.commit('setYear', y)
      let name = this.$route.name
      let parameters = this.$route.params
      let query = this.$route.query
      parameters.year = y
      this.$router.replace({  name: name, params: parameters, query: query }).catch(()=>{})
    },
    changeRegCity: function () {
      this.chgRegCity = !this.chgRegCity
    },
    resetCountry: function () {
        this.rstCountry = !this.rstCountry
    },
    loadIndi: async function () {
        let self = this
        return await axios.get('/indicators/indiRegions.json')
        .then(response => {
          self.$store.dispatch('setIndicators', response.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      
    loadIndiFUA: async function () {
      let self = this
        return await axios.get('/indicators/indiFUA.json')
        .then(response => {
          self.$store.dispatch('setIndicatorsFUA', response.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    loadIndiEFUA: async function () {
      let self = this
        return await axios.get('/indicators/indiEFUA.json')
        .then(response => {
          self.$store.dispatch('setIndicatorsEFUA', response.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    loadIndiCities: async function () {
      let self = this
        return await axios.get('/indicators/indiCities.json')
        .then(response => {
          //console.log(response.data)
          self.$store.dispatch('setIndicatorsCY', response.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    loadTableFUACities: async function () {
      let self = this
        return await axios.get('/centroids/Table_FUA_Cities.json')
        .then(response => {
            console.log(response.data) 
            self.$store.dispatch('setTableFUACities', response.data)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      

    loadFuas: async function () {
      let self = this
        return await axios.get('/centroids/fuas.json')
        .then(response => {
          let ar = []
          for (let d of response.data) {
            for (let c of d.children) {
              let obj = {}  
              obj.name = c['text']
              obj.lat = c['lat']
              obj.lon = c['lon']
              obj.id = c['id']
              obj.pop = c['Pop']
              obj.country = d.iso3
              self.elementsByKey[obj.id] = obj
              ar.push(obj)
            }
          }
          ar.sort((a, b) => {
              let fa = a.name.toLowerCase()
              let fb = b.name.toLowerCase()
              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          })
        self.$store.dispatch('setFUA', ar)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      
    loadEfuas: async function () {
      let self = this
      // return await axios.get('/cities.json')
      return await axios.get('/centroids/efuas.json')
        .then(response => {
          let ar = []
          for (let d of response.data) {
            for (let c of d.children) {
              let obj = {}  
              obj.name = c['text']
              obj.lat = c['lat']
              obj.lon = c['lon']
              obj.id = c['id']
              obj.pop = c['Pop']
              obj.country = d.iso3
              self.elementsByKey[obj.id] = obj
              ar.push(obj)
            }
          }
          ar.sort((a, b) => {
              let fa = a.name.toLowerCase()
              let fb = b.name.toLowerCase()
              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          })
          self.$store.dispatch('setEFUA', ar)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      
    loadCy: async function () {
      let self = this
      return await axios.get('/centroids/cities.json')
      // return await axios.get('/cy.json')
        .then(response => {
          let ar = []
          for (let d of response.data) {
            for (let c of d.children) {
              let obj = {}  
              obj.name = c['text']
              obj.lat = c['lat']
              obj.lon = c['lon']
              obj.id = c['id']
              obj.pop = c['Pop']
              obj.country = d.iso3
              self.elementsByKey[obj.id] = obj
              ar.push(obj)
            }
          }
          ar.sort((a, b) => {
              let fa = a.name.toLowerCase()
              let fb = b.name.toLowerCase()
              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          })
          self.$store.dispatch('setCY', ar)
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      

    loadFUASPolygon: async function (tu) {
      let self = this
      let filename = '/cache-geometry/FUAS/FUA-' + tu + '.json'
      return await axios.get(filename)
        .then(response => {
          self.$store.commit('setobjFUA', response.data)
        })
        .catch(e => {
          console.log(e)
        })
    },          
    loadCYPolygons: async function (tu) {
      console.log('*** LOAD CY POLYGON ***')
      console.log(tu)
      let self = this
      let filename = '/cache-geometry/CITIES/CY-' + tu + '.json'
      return await axios.get(filename)
        .then(response => {
          console.log(response.data)
          self.$store.commit('setobjCY', response.data)
        })
        .catch(e => {
          console.log(e)
          // this.errors.push(e)
        })
    },
    loadEFUAPolygon: async function (tu) {
      console.log('*** LOAD EFUAS POLYGON ***')
      console.log(tu)
      let self = this
      let filename = '/cache-geometry/EFUAS/EFUA-' + tu + '.json'
      return await axios.get(filename)
        .then(response => {
          //console.log(response.data)
          self.$store.commit('setobjEFUA', response.data)
        })
        .catch(e => {
          console.log(e)
          // this.errors.push(e)
        })
    },          

    loadTL2: async function () {
      let self = this
        return await axios.get('/cache-geometry/REGS/TL2.json')
        .then(response => {
          self.$store.commit('setobjTL2', response.data)
          let ar = []
          for (let f of response.data.features) {
            let obj = {}  
            obj.country = f.properties['COUNTRY']
            obj.name = f.properties['NAME']
            obj.code = f.properties['CODE']
            obj.type = f.geometry.type
            obj.coordinates = f.geometry.coordinates
            self.elementsByKey[obj.code] = obj
            ar.push(obj)
          }

          ar.sort((a, b) => {
              let fa = a.name.toLowerCase()
              let fb = b.name.toLowerCase()
              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          })


          console.log(ar)
          self.$store.dispatch('setTL2', ar)
        })
        .catch(e => {
          console.log(e)
          // this.errors.push(e)
        })
    },      
    loadTL3: async function () {
      let self = this
        return await axios.get('/cache-geometry/REGS/TL3.json')
        .then(response => {
          self.$store.commit('setobjTL3', response.data)
          let ar = []
          for (let f of response.data.features) {
            let obj = {}  
            obj.country = f.properties['COUNTRY']
            obj.name = f.properties['NAME']
            obj.code = f.properties['CODE']
            obj.parent = f.properties['PARENT']
            obj.type = f.geometry.type
            obj.coordinates = f.geometry.coordinates
            self.elementsByKey[obj.code] = obj
            ar.push(obj)
          }

          ar.sort((a, b) => {
              let fa = a.name.toLowerCase()
              let fb = b.name.toLowerCase()
              if (fa < fb) {
                  return -1
              }
              if (fa > fb) {
                  return 1
              }
              return 0
          })

          self.$store.dispatch('setTL3', ar)
        })
        .catch(e => {
          console.log(e)
          // this.errors.push(e)
        })
    },
    loadArrayCountries: async function () {
      let self = this
        return await axios.get('/centroids/countries.json')
        .then(response => {
          let ar = []
          for (let c of response.data.countries) {
            let obj = {}  
            obj.id = c['id']
            obj.name = c['name']
            obj.start = c['start']
            obj.end = c['end']
            obj.pop = c['pop']
            ar.push(obj)  
          }
          ar.sort()
          self.$store.dispatch('setCountries', ar)
          for (let c of self.$store.getters.countries) {
            this.countriesByCode[c.id] = c.name
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    loadArrayLev: function () {
      let numberElementByCountry = {}
      for (let m of this.$store.getters.TL3) {
        m = JSON.parse(JSON.stringify(m))

        let ob = {}
        ob.key = m['country']
        ob.country = m['country']
        ob.key_TL2 = m['parent']
        ob.key_TL3 = m['code']
        ob.value = m['name']
        ob.code = m['code']
        ob.type = m['type']
        ob.coordinates = m['coordinates']

        if (!numberElementByCountry[ob.key]) {
          numberElementByCountry[ob.key] = {}
        }
        if (!numberElementByCountry[ob.key].TL3) {
          numberElementByCountry[ob.key] = {'TL3': 0}
        }
        numberElementByCountry[ob.key].TL3 = numberElementByCountry[ob.key].TL3 + 1
      }

      for (let m of this.$store.getters.TL2) {
        m = JSON.parse(JSON.stringify(m))
        let ob = {}
        ob.key = m['country']
        ob.country = m['country_name']
        ob.key_TL2 = m['code']
        ob.des = m['name']
        ob.value = m['name']
        ob.code = m['code']
        ob.type = m['type']
        ob.coordinates = m['coordinates']
        if (!numberElementByCountry[ob.key]) {
          numberElementByCountry[ob.key] = {}
        }
        if (!numberElementByCountry[ob.key].TL2) {
          numberElementByCountry[ob.key]['TL2'] = 0
        }
        numberElementByCountry[ob.key].TL2 = numberElementByCountry[ob.key].TL2 + 1
      }

      for (let m of this.$store.getters.FUA) {
        let ob = {}
        ob.des = m['name']
        ob.lat = m['lat']
        ob.lon = m['lon']
        ob.code = m['id']
        ob.key = m['country']

        if (!numberElementByCountry[ob.key]) {
          numberElementByCountry[ob.key] = {}
        }
        if (!numberElementByCountry[ob.key].FUA) {
          numberElementByCountry[ob.key]['FUA'] = 0
        }
        numberElementByCountry[ob.key].FUA = numberElementByCountry[ob.key].FUA + 1
      }

      for (let m of this.$store.getters.EFUA) {
        let ob = {}
        ob.des = m['name']
        ob.lat = m['lat']
        ob.lon = m['lon']
        ob.code = m['id']
        ob.key = m['country']          
        if (!numberElementByCountry[ob.key]) {
          numberElementByCountry[ob.key] = {}
        }
        if (!numberElementByCountry[ob.key].CITY) {
          numberElementByCountry[ob.key]['CITY'] = 0
        }
        numberElementByCountry[ob.key].CITY = numberElementByCountry[ob.key].CITY + 1
      }

      for (let m of this.$store.getters.CY) {
        let ob = {}
        ob.des = m['name']
        ob.lat = m['lat']
        ob.lon = m['lon']
        ob.code = m['id']
        ob.key = m['country']          
        if (!numberElementByCountry[ob.key]) {
          numberElementByCountry[ob.key] = {}
        }
        if (!numberElementByCountry[ob.key].CY) {
          numberElementByCountry[ob.key]['CY'] = 0
        }
        numberElementByCountry[ob.key].CY = numberElementByCountry[ob.key].CY + 1
      }


      this.$store.commit('setCountryElements', numberElementByCountry)
    },
    change_tu: function (e) {
      let name = this.$route.name
      let params = this.$route.params
      let query = this.$route.query
      let country_ok = true
      if (params.tl === 'EFUA' ){
        if (e !== undefined && e !== 'x' ) {
          /*
          if (isNaN(e)){
            if (!this.countriesByCode[e]) {
                alert('COUNTRY NOT AVAILABLE')
                country_ok = false
            }
          }
          */
        }
      }
      if (country_ok) {
        if (e) {
          var keys = Object.keys(this.countriesByCode)
          if (keys.includes(e)) {
            if (name !== 'SubAreaChart') {
              name = 'SubArea'
            }
            params.c = e
            params.tu = 'x'
          }
          else {
            let tl = this.$route.params.tl
            let tu_obj = this.$store.getters.allTUByCode[e]
            if (tl === 'TL2') {
              tu_obj = this.$store.getters.getTL2ByCode(e)
            }
            else if (tl === 'TL3') {
              tu_obj = this.$store.getters.getTL3ByCode(e)
            }
            else if (tl === "FUA") {
              tu_obj = this.$store.getters.getFUAByCode(e)
            }
            else if (tl === "EFUA") {
              tu_obj = this.$store.getters.getEFUAByCode(e)
            }
            else if (tl === "CY") {
              tu_obj = this.$store.getters.getCYByCode(e)
            }

            //console.log(tu_obj)
            if (tu_obj) {
              params.c = tu_obj.country
            }
            params.tu = e
            if (name !== 'MetroRegionalChart') {
              name = 'MetroRegional'
            }
            if (params.ctu == undefined ){
              params.ctu = 'x'
            }
          }
          if (e === 'x') {
            name = 'Home'
            params.c = 'x'
          }
          this.$router.replace({ name: name, params: params, query: query}).catch(()=>{})
        }
      }
    },
    loadProjections: function () {
      proj4.defs("ESRI:102009","+proj=lcc +lat_1=20 +lat_2=60 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs")
      proj4.defs("EPSG:3035","+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs")
      register(proj4);
      this.$store.dispatch('setEuropeProjection', getProjection('EPSG:3035'))
      this.$store.dispatch('setNorthAmericaProjection', getProjection('ESRI:102009'))
    },
    loadLegendColor: function (typeLegend) {

      if (typeLegend === 0) {

        this.legendColors = [
          'rgba(255, 247, 178, 1)',
          'rgba(240, 208, 144, 1)',
          'rgba(224, 160, 112, 1)',
          'rgba(224, 96, 64, 1)',
          'rgba(208, 48, 32, 1)',
          'rgba(192, 0, 0, 1)',
          null,
          null,
          null, 
          'rgba(200, 200, 200, 0.8)',
          'rgba(0, 255, 0, 0.8)'
          ]
        } else {
        this.legendColors = [
          'rgba(144, 224, 239, 1)',
          'rgba(72, 193, 228, 1)',
          'rgba(0, 180, 216, 1)',
          'rgba(0, 150, 199, 1)',
          'rgba(0, 119, 182, 1)',
          'rgba(2, 62, 138, 1)',
          null,
          null,
          null, 
          'rgba(200, 200, 200, 0.8)',
          'rgba(0, 255, 0, 0.8)'                  
          ]
        }      

        this.$store.dispatch('setLegendColors', this.legendColors)
        this.$store.dispatch('setLegendColorsDefault', this.legendColors)
    },
    async initAll () {
      this.$store.commit('setshow_overlay', true)
      console.log('*** START INIT ALL ***')
      await this.loadDefaultValues()
      this.progressValue = '4%'
      console.log('**** Init legend color ***')
      this.loadLegendColor(0)
      this.loadProjections()

      this.progressValue = '13%'
      //--- await this.loadMap
      console.log("=== 1 === loadEfuas")
      await this.loadEfuas()          

      this.progressValue = '15%'
      //--- await this.loadMap
      console.log("=== 1 === loadCy")
      await this.loadCy()          

      this.progressValue = '18%'
      console.log("=== 2 === loadFuas")
      await this.loadFuas()

      this.progressValue = '40%'
      console.log("=== 2 === loadFuas")
      await this.loadTableFUACities()

      this.progressValue = '46%'
      console.log("=== 3 === loadTL2")
      await this.loadTL2()

      console.log("=== 4 === loadTL3")
      await this.loadTL3()

      this.progressValue = '74%'
      /*
      console.log("=== 5 === loadYears2")
      await this.loadYears2()
      this.progressValue = '75%'
      console.log("=== 6 === loadYears3")
      await this.loadYears3()
      this.progressValue = '76%'
      */
      console.log("=== 7 === loadArrayCountries")
      await this.loadArrayCountries()
      console.log("=== 8 === resetCountry")
      this.progressValue = '82%'
      await this.resetCountry()
      /*
      console.log("=== 9 === loadPopulations")
      this.progressValue = '83%'
      await this.loadPopulations()
      */
      console.log("=== 10 === loadIndi")
      this.progressValue = '84%'
      await this.loadIndi()
      console.log("=== 11 === loadIndiFUA")
      this.progressValue = '86%'
      await this.loadIndiFUA()
      console.log("=== 12 === loadIndiEFUA")
      this.progressValue = '88%'
      await this.loadIndiEFUA()
      console.log("=== 12 === loadIndiCities")
      this.progressValue = '90%'
      await this.loadIndiCities()
      console.log("=== 15 === loadArrayLev")
      this.progressValue = '95%'
      this.loadArrayLev()
      this.progressValue = '98%'
      this.$store.commit('setshow_overlay', false)
      this.$root.$on('change_tu', (e) => {
          this.change_tu(e)
      })
      this.progressValue = '98%'
      console.log("=== 16 === getParams")
      await this.getParams()
      this.progressValue = ''
      this.progressValue = '99%'
      // console.log(this.elementsByKey)
      this.$store.commit('setAllTUByCode', this.elementsByKey)
      // console.log("=== 16 ===")
      // this.$root.$emit('manage_layers')
      this.progressValue = '100%'
    },
    loadDefaultValues: async function() {
        return await axios.get('/settings/parameters.json')
          .then(response => {
            let ar = []
            for (let tl of response.data.territorial_levels_R) {
              let obj = {}  
              obj.id = tl['id']
              obj.name = tl['name']
              ar.push(obj)
            }
            this.$store.dispatch('setTerritorial_levels_R', ar)
            ar = []
            for (let tl of response.data.territorial_levels_C) {
              let obj = {}  
              obj.id = tl['id']
              obj.name = tl['name']
              ar.push(obj)
            }
            this.$store.dispatch('setTerritorial_levels_C', ar)
          })
          .catch(e => {
            this.errors.push(e)
          })
    }
  },
  mounted () {
    console.log('>>>> MOUNT APP<<<<')
    document.title = 'OECD Atlas'
    this.initAll()
  },

  data: () => ({
    filterChanged: false,
    currYear: 0,
    years2: null,
    years3: null,
    chgRegCity: false, 
    rstCountry: false,
    prevName: '',
    available_years:[],
    legendColor: [],
    overlay: false,
    currentYear: null,
    progressValue:'',
    countriesByCode: {},
    dialog: false,
    dialogTitle: '',
    dialogMessage: '',
    errors: [],
    elementsByKey: {},
    lastYearAvailable: false,
    isIsrael: false
  }),
};
</script>


<style>
.apptoolbar {
  border-bottom-color: #b6b3b3;
  border-bottom-width: 15px;
  border-bottom-style: solid;
}

.panel-right {
    width:300px;
}

.oecd_header {
  height: 50px;
  max-height: 50px;
}

.oecd_box_top {
  width: 85px;
  height: 50px;
  font-family: 'OpenSansLight';
  font-size: 8pt;
  line-height: 50px;
  color: #666666;
  border-left-color: #b6b3b3;
  border-left-width: 1px;
  border-left-style: solid;
  text-align: center;
  vertical-align: middle;
}

.divaffiancate {
float:left; 
display:block; 
}

.filtercomponent {
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  position: absolute;
  z-index: 7;
} 

.container {
  position: relative;
}

.over {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
}

.item1 { grid-area: header; }
.item2 { grid-area: menu; }
.item3 { grid-area: main; }
.item4 { grid-area: right; }
.item5 { grid-area: footer; }


.grid-container {
  display: grid;
  grid-template-columns: 50px 70% 2% ;
  grid-template-areas:
    'header header header header header header'
    'menu main main main main right'
    'footer footer footer footer footer footer';
  grid-gap: 1px;
  background-color: rgb(255, 255, 255);
  padding: 0px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 0px 0;
  font-size: 20px;
}


.opensansbold {
  font-family: 'OpenSansBold';
}


.size7 {
  font-size: 7pt;
}

.size8 {
  font-size: 8pt;
}

.size9 {
  font-size: 9pt;
}

.size10 {
  font-size: 10pt;
}

.size11 {
  font-size: 11pt;
}

.size12 {
  font-size: 12pt;
}

.opensansregularcase {
  font-family: 'OpenSansRegular';
}

.opensansregular {
  font-family: 'OpenSansRegular';
}
.opensanslight {
  font-family: 'OpenSansLight';
}

.ucase {
  text-transform:uppercase;
}
.cursorhand {
  cursor: pointer;
}

</style>
